// extracted by mini-css-extract-plugin
export default {"title":"title_title__o2Exw","red-line":"title_red-line__J3TpW"};